/**
 * WorldSeed entity schema
 */

import { z } from 'zod';
import { ContentRatingSchema, ReasoningEffortSchema } from '../enums';

export const WorldSeedSchema = z.object({
  id: z.string(),
  world_id: z.string(),
  original_prompt: z.string(),
  setting_definition: z.string(),
  genre: z.string(),
  tone: z.string(),
  themes: z.array(z.string()).nullable(),
  world_rules: z.array(z.string()).nullable(),
  initial_situation: z.string().nullable(),
  content_rating: ContentRatingSchema,
  allow_nsfw: z.boolean(),
  provider: z.string().nullable(),
  model: z.string().nullable(),
  fallback_provider: z.string().nullable(),
  fallback_model: z.string().nullable(),
  reasoning_effort: ReasoningEffortSchema.nullable(),
  current_turn: z.number().int().nonnegative(),
  current_location: z.string().nullable(),
  current_chapter_id: z.string().nullable(),
  created_at: z.string(),
});

export type WorldSeed = z.infer<typeof WorldSeedSchema>;
